// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Future from "reason-future/src/Future.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_format from "rescript/lib/es6/caml_format.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as GoTo$LiveRoom from "../../GoTo.bs.js";
import * as Header$LiveRoom from "./Header.bs.js";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as MomentTZ$LiveRoom from "../../bindings/MomentTZ.bs.js";
import * as ClockStore$LiveRoom from "../../stores/ClockStore.bs.js";
import * as LiveStream$LiveRoom from "../../stores/LiveStream.bs.js";
import * as LotContent$LiveRoom from "./LotContent.bs.js";
import * as PropSpread$LiveRoom from "../../components/PropSpread.bs.js";
import * as FeedSection$LiveRoom from "./FeedSection.bs.js";
import * as LotCardList$LiveRoom from "./LotCardList.bs.js";
import * as LotCarousel$LiveRoom from "./LotCarousel.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as Translations$LiveRoom from "../../../../translations/Translations.bs.js";
import * as AuthTokenHook$LiveRoom from "../../stores/AuthTokenHook.bs.js";
import * as MiddleSection$LiveRoom from "./MiddleSection.bs.js";
import * as ParcelModalV2$LiveRoom from "../../components/Modal/ParcelModalV2.bs.js";
import * as SterlingIcons$LiveRoom from "../../bindings/SterlingIcons.bs.js";
import * as Utils_Auction$LiveRoom from "../../Utils/Utils_Auction.bs.js";
import * as CurrentLotCard$LiveRoom from "./CurrentLotCard.bs.js";
import * as SterlingTokens$LiveRoom from "../../bindings/SterlingTokens.bs.js";
import * as StyleConstants$LiveRoom from "../../styles/StyleConstants.bs.js";
import * as Button from "@sothebys/sterling/button";
import * as AnalyticsManager$LiveRoom from "../../analytics/AnalyticsManager.bs.js";
import * as ClientapiQueries$LiveRoom from "../../ClientapiQueries.bs.js";
import * as ActionNeededToBid$LiveRoom from "./ActionNeededToBid.bs.js";
import * as ShowSelectAccount$LiveRoom from "../../ShowSelectAccount.bs.js";
import * as TestAuctionBanner$LiveRoom from "../../components/TestAuctionBanner.bs.js";
import * as Utils_Breakpoints$LiveRoom from "../../Utils/Utils_Breakpoints.bs.js";
import * as AuctionClosedModal$LiveRoom from "../../components/Modal/AuctionClosedModal.bs.js";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";
import * as AlternativeCurrency$LiveRoom from "../../stores/AlternativeCurrency.bs.js";
import * as Utils_IdRestriction$LiveRoom from "../../Utils/Utils_IdRestriction.bs.js";
import * as BetweenSessionModalV2$LiveRoom from "../../components/Modal/BetweenSessionModalV2.bs.js";
import * as AuctionEnrollmentModal$LiveRoom from "../../components/Modal/AuctionEnrollmentModal.bs.js";
import * as AuctionRoomSharedContacts$LiveRoom from "../../components/AuctionRoomSharedContacts.bs.js";
import * as SubmitIdentificationModal$LiveRoom from "../../components/Modal/SubmitIdentificationModal.bs.js";
import * as WelcomeToAuctionroomModal$LiveRoom from "../../components/Modal/WelcomeToAuctionroomModal.bs.js";
import * as ActionNeededPendingEnrollment$LiveRoom from "../../components/Modal/ActionNeededPendingEnrollment.bs.js";
import * as RegistrationPendingAgentModal$LiveRoom from "../../components/Modal/RegistrationPendingAgentModal.bs.js";

function leftSideContainerStyle(showList) {
  return Curry._1(Css.style, {
              hd: CommonStyles$LiveRoom.mediaV2(/* MobileAndTablet */3, {
                    hd: Css.position("fixed"),
                    tl: {
                      hd: Css.top(Css.px(StyleConstants$LiveRoom.headerHeight)),
                      tl: {
                        hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                        tl: {
                          hd: Css.height({
                                NAME: "subtract",
                                VAL: [
                                  Css.pct(100),
                                  Css.px(StyleConstants$LiveRoom.headerHeight)
                                ]
                              }),
                          tl: {
                            hd: Css.width(Css.px(StyleConstants$LiveRoom.sidebarsWidth)),
                            tl: {
                              hd: Css.zIndex(StyleConstants$LiveRoom.modalOnTopZIndex),
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  }),
              tl: {
                hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                      hd: Css.display("none"),
                      tl: /* [] */0
                    }),
                tl: {
                  hd: Css.width(showList ? Css.px(StyleConstants$LiveRoom.sidebarsWidth) : Css.px(0)),
                  tl: {
                    hd: Css.transform(Css.translateX(Css.pct(showList ? 0.0 : -100.0))),
                    tl: {
                      hd: Css.transition(StyleConstants$LiveRoom.animationFast, undefined, undefined, "all"),
                      tl: {
                        hd: Css.overflow("visible"),
                        tl: {
                          hd: Css.display("flex"),
                          tl: {
                            hd: Css.flexDirection("column"),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

function AuctionRoomPage$LayoutDesktopAndTabletLandscape(props) {
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.position("fixed"),
                    tl: {
                      hd: Css.width(Css.pct(100)),
                      tl: {
                        hd: Css.height(Css.pct(100)),
                        tl: {
                          hd: Css.display("grid"),
                          tl: {
                            hd: Css.gridTemplateColumns({
                                  hd: "minContent",
                                  tl: {
                                    hd: "auto",
                                    tl: {
                                      hd: Css.px(StyleConstants$LiveRoom.sidebarsWidth),
                                      tl: /* [] */0
                                    }
                                  }
                                }),
                            tl: {
                              hd: Css.gridTemplateRows({
                                    hd: props.isTestAuction ? "auto" : "zero",
                                    tl: {
                                      hd: {
                                        NAME: "px",
                                        VAL: StyleConstants$LiveRoom.headerHeight
                                      },
                                      tl: {
                                        hd: {
                                          NAME: "minmax",
                                          VAL: [
                                            Css.px(0),
                                            Css.auto
                                          ]
                                        },
                                        tl: /* [] */0
                                      }
                                    }
                                  }),
                              tl: {
                                hd: CommonStyles$LiveRoom.mediaV2(/* MobileAndTablet */3, {
                                      hd: Css.gridTemplateColumns({
                                            hd: "auto",
                                            tl: {
                                              hd: Css.px(StyleConstants$LiveRoom.sidebarsWidth),
                                              tl: /* [] */0
                                            }
                                          }),
                                      tl: /* [] */0
                                    }),
                                tl: {
                                  hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                                        hd: Css.display("none"),
                                        tl: /* [] */0
                                      }),
                                  tl: /* [] */0
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  })
            }, props.children);
}

var LayoutDesktopAndTabletLandscape = {
  make: AuctionRoomPage$LayoutDesktopAndTabletLandscape
};

function AuctionRoomPage$LayoutTabletPortraitAndMobile(props) {
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.position("fixed"),
                    tl: {
                      hd: Css.width(Css.pct(100.0)),
                      tl: {
                        hd: Css.height(Css.pct(100.0)),
                        tl: {
                          hd: Css.display("grid"),
                          tl: {
                            hd: Css.gridTemplateRows({
                                  hd: props.isTestAuction ? Css.px(18) : Css.px(0),
                                  tl: {
                                    hd: {
                                      NAME: "px",
                                      VAL: StyleConstants$LiveRoom.headerHeight
                                    },
                                    tl: {
                                      hd: {
                                        NAME: "minmax",
                                        VAL: [
                                          Css.px(0),
                                          Css.auto
                                        ]
                                      },
                                      tl: /* [] */0
                                    }
                                  }
                                }),
                            tl: {
                              hd: Css.gridTemplateColumns({
                                    hd: {
                                      NAME: "fr",
                                      VAL: 1
                                    },
                                    tl: /* [] */0
                                  }),
                              tl: {
                                hd: CommonStyles$LiveRoom.mediaV2(/* DesktopAndTabletLandscape */4, {
                                      hd: Css.display("none"),
                                      tl: /* [] */0
                                    }),
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      }
                    }
                  })
            }, props.children);
}

var LayoutTabletPortraitAndMobile = {
  make: AuctionRoomPage$LayoutTabletPortraitAndMobile
};

function AuctionRoomPage$ToggleLotListButton(props) {
  var onToggle = props.onToggle;
  var showList = props.showList;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.position("absolute"),
                    tl: {
                      hd: Css.width(Css.px(32)),
                      tl: {
                        hd: Css.height(Css.px(32)),
                        tl: {
                          hd: Css.right(Css.px(-32)),
                          tl: {
                            hd: Css.top(Css.px(32)),
                            tl: {
                              hd: Css.zIndex(1),
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }
                  })
            }, showList ? React.createElement(PropSpread$LiveRoom.make, {
                    aria: {
                      hd: {
                        TAG: /* Label */3,
                        _0: Curry._1(t, "LotListButton_ariaLabel_close")
                      },
                      tl: /* [] */0
                    },
                    children: React.createElement(Button.Button, {
                          onClick: (function (param) {
                              Curry._1(onToggle, !showList);
                            }),
                          className: Curry._1(Css.style, {
                                hd: Css.marginLeft(Css.px(-1)),
                                tl: {
                                  hd: Css.position("absolute"),
                                  tl: {
                                    hd: Css.border({
                                          NAME: "px",
                                          VAL: 1
                                        }, "solid", Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey50_nohashtag)),
                                    tl: {
                                      hd: Css.borderTopLeftRadius(Css.px(0)),
                                      tl: {
                                        hd: Css.borderBottomLeftRadius(Css.px(0)),
                                        tl: {
                                          hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }
                                }
                              }),
                          buttonStyle: "tertiary",
                          size: "smallIcon",
                          children: React.createElement(SterlingIcons$LiveRoom.Collection.ArrowHide24.make, {})
                        })
                  }) : React.createElement(PropSpread$LiveRoom.make, {
                    aria: {
                      hd: {
                        TAG: /* Label */3,
                        _0: Curry._1(t, "LotListButton_ariaLabel_open")
                      },
                      tl: /* [] */0
                    },
                    children: React.createElement(Button.Button, {
                          onClick: (function (param) {
                              Curry._1(onToggle, !showList);
                            }),
                          className: Curry._1(Css.style, {
                                hd: Css.marginLeft(Css.px(2)),
                                tl: {
                                  hd: Css.position("absolute"),
                                  tl: {
                                    hd: Css.border({
                                          NAME: "px",
                                          VAL: 1
                                        }, "solid", Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey50_nohashtag)),
                                    tl: {
                                      hd: Css.borderTopLeftRadius(Css.px(0)),
                                      tl: {
                                        hd: Css.borderBottomLeftRadius(Css.px(0)),
                                        tl: /* [] */0
                                      }
                                    }
                                  }
                                }
                              }),
                          buttonStyle: "tertiary",
                          size: "smallIcon",
                          children: React.createElement(SterlingIcons$LiveRoom.Collection.ArrowShow24.make, {})
                        })
                  }));
}

var ToggleLotListButton = {
  make: AuctionRoomPage$ToggleLotListButton
};

function AuctionRoomPage$ModalHandler(props) {
  var selectAccountInQuery = props.selectAccountInQuery;
  var authToken = props.authToken;
  var me = props.me;
  var setModalToShow = props.setModalToShow;
  var modalToShow = props.modalToShow;
  var fragment = props.fragment;
  var match = React.useState(function () {
        return true;
      });
  var setComingIntoAuctionroom = match[1];
  var comingIntoAuctionroom = match[0];
  var isMultipleSession = React.useMemo((function () {
          return fragment.sessions.length >= 2;
        }), []);
  var isAuctionInBetweenSession = React.useMemo((function () {
          if (isMultipleSession && !(Belt_Array.some(fragment.sessions, (function (x) {
                      return x.state.state === "Open";
                    })) || !Belt_Array.some(fragment.sessions, (function (x) {
                      return x.state.state === "Closed";
                    })))) {
            return Belt_Array.some(fragment.sessions, (function (x) {
                          return x.state.state === "PreOpen";
                        }));
          } else {
            return false;
          }
        }), fragment.sessions);
  var isAuctionClosed = React.useMemo((function () {
          var match = fragment.bidPhase.auctionBidPhase;
          if (typeof match === "object" && match.NAME === "LiveAuctionBidPhaseType") {
            return match.VAL.liveBidPhase === "Closed";
          } else {
            return false;
          }
        }), [fragment.bidPhase]);
  var $$location = Belt_Option.mapWithDefault(fragment.location, "", (function (x) {
          return x.displayLocation.name;
        }));
  React.useEffect((function () {
          if (isAuctionClosed) {
            Curry._1(setModalToShow, /* AuctionClosedModal */5);
          } else {
            var exit = 0;
            var exit$1 = 0;
            if (selectAccountInQuery !== undefined && selectAccountInQuery && typeof authToken === "object" && authToken.NAME === "Authenticated") {
              if (me.transactional && Belt_Option.isNone(me.paddleId)) {
                Future.get(Utils_IdRestriction$LiveRoom.checkForId(undefined, me, undefined), (function (res) {
                        var status = res.status;
                        if (status !== 0) {
                          if (status >= 5) {
                            return ;
                          } else {
                            return Curry._1(setModalToShow, {
                                        TAG: /* SubmitIdentificationModal */1,
                                        _0: status
                                      });
                          }
                        } else {
                          return Curry._1(setModalToShow, /* SelectAccount */1);
                        }
                      }));
              } else {
                exit = 1;
              }
            } else {
              exit$1 = 2;
            }
            if (exit$1 === 2) {
              if (authToken === "Unauthenticated" && !isAuctionInBetweenSession) {
                Curry._1(setModalToShow, /* WelcomeToAuctionroomModal */4);
              } else {
                exit = 1;
              }
            }
            if (exit === 1) {
              if (isAuctionInBetweenSession) {
                Curry._1(setModalToShow, {
                      TAG: /* BetweenSession */0,
                      _0: comingIntoAuctionroom
                    });
              } else if (typeof authToken === "object" && authToken.NAME === "Authenticated" && me.transactional && Belt_Option.isSome(me.paddleId)) {
                AnalyticsManager$LiveRoom.auctionRoomEntered(fragment.auctionId, fragment.title, fragment.sapSaleNumber, "Bidder");
              }
              
            }
            
          }
          Curry._1(setComingIntoAuctionroom, (function (param) {
                  return false;
                }));
        }), [
        authToken,
        isAuctionInBetweenSession,
        isAuctionClosed
      ]);
  var lot = fragment.currentLot.auctionCurrentLotFragment.lot;
  var bidType = Belt_Option.flatMap(lot, (function (lot) {
          return Belt_Option.map(lot.bidState, (function (bidState) {
                        return bidState.bidType;
                      }));
        }));
  React.useEffect((function () {
          var match = Belt_Option.map(lot, (function (lot) {
                  return lot.lotId;
                }));
          var match$1 = Belt_Option.flatMap(lot, (function (lot) {
                  return lot.parcel;
                }));
          var match$2 = Belt_Option.flatMap(lot, (function (lot) {
                  return lot.latestBid.bid;
                }));
          if (typeof modalToShow === "number") {
            if (modalToShow === /* NoModal */0 && match !== undefined && match$1 !== undefined) {
              var canSellAdditionalCount = match$1.canSellAdditionalCount;
              if (canSellAdditionalCount !== undefined && bidType !== undefined && typeof bidType === "object" && bidType.NAME === "LiveBidType" && bidType.VAL.liveBidPhase === "ConfirmingResult" && match$2 !== undefined) {
                var match$3 = match$2.bidState;
                if ((match$3 === "CurrentBid" || match$3 === "MaxBid" || match$3 === "Absentee") && canSellAdditionalCount > 0) {
                  Curry._1(setModalToShow, {
                        TAG: /* ParcelModal */2,
                        _0: match
                      });
                }
                
              }
              
            }
            
          } else if (modalToShow.TAG === /* ParcelModal */2) {
            if (match !== undefined && bidType !== undefined && typeof bidType === "object" && bidType.NAME === "LiveBidType" && bidType.VAL.liveBidPhase === "Closed" && modalToShow._0 === match) {
              Curry._1(setModalToShow, /* NoModal */0);
            }
            
          }
          
        }), [
        bidType,
        modalToShow
      ]);
  var tmp;
  if (typeof modalToShow === "number") {
    switch (modalToShow) {
      case /* NoModal */0 :
          tmp = null;
          break;
      case /* SelectAccount */1 :
          tmp = React.createElement(AuctionEnrollmentModal$LiveRoom.make, {
                fragment: props.enrollmentModalFragment,
                auctionId: fragment.auctionId,
                onClose: (function (param) {
                    Curry._1(setModalToShow, /* NoModal */0);
                  }),
                nextStep: props.nextEnrollmentStep,
                saleNumber: fragment.sapSaleNumber
              });
          break;
      case /* ActionNeededToBid */2 :
          tmp = React.createElement(ActionNeededToBid$LiveRoom.make, {
                onClose: (function (param) {
                    Curry._1(setModalToShow, /* NoModal */0);
                  })
              });
          break;
      case /* PendingAgentModal */3 :
          tmp = React.createElement(RegistrationPendingAgentModal$LiveRoom.make, {
                location: $$location,
                sapAuctionSaleNumber: fragment.sapSaleNumber,
                onClose: (function (param) {
                    Curry._1(setModalToShow, /* NoModal */0);
                  })
              });
          break;
      case /* WelcomeToAuctionroomModal */4 :
          tmp = React.createElement(WelcomeToAuctionroomModal$LiveRoom.make, {
                fragment: props.welcomeAuctionRoomModalFragment,
                closeModal: (function (param) {
                    Curry._1(setModalToShow, /* NoModal */0);
                    AnalyticsManager$LiveRoom.auctionRoomEntered(fragment.auctionId, fragment.title, fragment.sapSaleNumber, "Watcher");
                  })
              });
          break;
      case /* AuctionClosedModal */5 :
          tmp = React.createElement(AuctionClosedModal$LiveRoom.make, {
                auctionUrl: props.auctionUrl,
                closeModal: (function (param) {
                    Curry._1(setModalToShow, /* NoModal */0);
                  })
              });
          break;
      case /* ActionNeededPendingEnrollment */6 :
          tmp = React.createElement(ActionNeededPendingEnrollment$LiveRoom.make, {
                onClose: (function (param) {
                    Curry._1(setModalToShow, /* NoModal */0);
                  }),
                location: AuctionRoomSharedContacts$LiveRoom.getAuctionLocationType(Belt_Option.mapWithDefault(fragment.location, "", (function (l) {
                            return l.displayLocation.name;
                          })))
              });
          break;
      
    }
  } else {
    switch (modalToShow.TAG | 0) {
      case /* BetweenSession */0 :
          tmp = React.createElement(BetweenSessionModalV2$LiveRoom.make, {
                auctionId: fragment.auctionId,
                closeModal: (function (param) {
                    Curry._1(setModalToShow, /* NoModal */0);
                    GoTo$LiveRoom.auctionDetails(Utils_Auction$LiveRoom.getAuctionUrl(fragment.slug.name, fragment.slug.year, undefined, undefined));
                  }),
                comingIntoBetweenSession: modalToShow._0
              });
          break;
      case /* SubmitIdentificationModal */1 :
          tmp = React.createElement(SubmitIdentificationModal$LiveRoom.make, {
                onClose: (function (param) {
                    Curry._1(setModalToShow, /* NoModal */0);
                  }),
                modalType: modalToShow._0,
                saleNumber: fragment.sapSaleNumber
              });
          break;
      case /* ParcelModal */2 :
          tmp = React.createElement(ParcelModalV2$LiveRoom.make, {
                lotId: modalToShow._0,
                onClose: (function (param) {
                    Curry._1(setModalToShow, /* NoModal */0);
                  })
              });
          break;
      
    }
  }
  return React.createElement(React.Fragment, undefined, tmp);
}

var ModalHandler = {
  make: AuctionRoomPage$ModalHandler
};

function withErrorRecovery(subscriptionRes, onSubscriptionError, id) {
  var isSubscriptionError = Belt_Option.mapWithDefault(subscriptionRes.error, false, (function (error) {
          return error.graphQLErrors.length !== 0;
        }));
  React.useEffect((function () {
          if (isSubscriptionError) {
            Curry._1(onSubscriptionError, id);
          }
          
        }), [isSubscriptionError]);
}

function useLotOnDisplay(currentLot) {
  var match = React.useState(function () {
        return /* CurrentLot */0;
      });
  var setLotOnDisplay = match[1];
  var lotOnDisplay = match[0];
  var tmp;
  tmp = typeof lotOnDisplay === "number" ? "Should be skipped if not requesting to view lot" : (
      lotOnDisplay.TAG === /* RequestingToViewLot */0 ? lotOnDisplay._0 : lotOnDisplay._0.lotId
    );
  var lotOnDispayQueryResult = Curry.app(ClientapiQueries$LiveRoom.LotOnDisplay.LotOnDisplayQuery.use, [
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        typeof lotOnDisplay === "number" ? true : false,
        undefined,
        Curry._3(ClientapiQueries$LiveRoom.LotOnDisplay.LotOnDisplayQuery.makeVariables, tmp, Translations$LiveRoom.getCatalogingLanguage(undefined), undefined)
      ]);
  React.useEffect((function () {
          var match = lotOnDispayQueryResult.data;
          if (match !== undefined) {
            var match$1 = match.lotV2;
            if (match$1 !== undefined && typeof match$1 === "object" && match$1.NAME === "LotV2") {
              var lot = match$1.VAL;
              var selectingCurrentLiveLot = Belt_Option.mapWithDefault(currentLot, false, (function (c) {
                      return c.lotId === lot.lotOnDisplayLotFragment.lotId;
                    }));
              Curry._1(setLotOnDisplay, (function (param) {
                      return {
                              TAG: /* ViewingLot */1,
                              _0: lot.lotOnDisplayLotFragment,
                              _1: selectingCurrentLiveLot
                            };
                    }));
            }
            
          }
          
        }), [lotOnDispayQueryResult.data]);
  var previousLotViewed = React.useRef(undefined);
  React.useEffect((function () {
          if (typeof lotOnDisplay !== "number" && lotOnDisplay.TAG !== /* RequestingToViewLot */0) {
            previousLotViewed.current = lotOnDisplay._0;
          }
          
        }), [lotOnDisplay]);
  var lot = React.useMemo((function () {
          if (typeof lotOnDisplay !== "number" && lotOnDisplay.TAG !== /* RequestingToViewLot */0) {
            if (lotOnDisplay._1) {
              return currentLot;
            } else {
              return lotOnDisplay._0;
            }
          }
          var match = previousLotViewed.current;
          if (match !== undefined) {
            return match;
          } else if (currentLot !== undefined) {
            return currentLot;
          } else {
            return ;
          }
        }), [
        currentLot,
        lotOnDisplay
      ]);
  var requestToViewLot = React.useCallback((function (lotId) {
          Curry._1(setLotOnDisplay, (function (param) {
                  return {
                          TAG: /* RequestingToViewLot */0,
                          _0: lotId
                        };
                }));
        }), []);
  var selectedLotId;
  selectedLotId = typeof lotOnDisplay === "number" ? Belt_Option.getWithDefault(Belt_Option.map(currentLot, (function (c) {
                return c.lotId;
              })), "") : (
      lotOnDisplay.TAG === /* RequestingToViewLot */0 ? lotOnDisplay._0 : (
          lotOnDisplay._1 ? Belt_Option.getWithDefault(Belt_Option.map(currentLot, (function (c) {
                        return c.lotId;
                      })), "") : lotOnDisplay._0.lotId
        )
    );
  return [
          selectedLotId,
          lot,
          requestToViewLot
        ];
}

function AuctionRoomPage(props) {
  var auction = props.auction;
  var match = I18next$LiveRoom.useTranslation(undefined);
  MomentTZ$LiveRoom.init(undefined);
  var match$1 = React.useReducer((function (state, action) {
          switch (action.TAG | 0) {
            case /* SetModalToShow */0 :
                return {
                        modalToShow: action._0,
                        toggleMobileLotListClick: state.toggleMobileLotListClick,
                        alternativeCurrency: state.alternativeCurrency,
                        showLotCardList: state.showLotCardList,
                        showLotDetails: state.showLotDetails
                      };
            case /* SetToggleMobileLotListClick */1 :
                return {
                        modalToShow: state.modalToShow,
                        toggleMobileLotListClick: action._0,
                        alternativeCurrency: state.alternativeCurrency,
                        showLotCardList: state.showLotCardList,
                        showLotDetails: state.showLotDetails
                      };
            case /* SetAlternativeCurrency */2 :
                return {
                        modalToShow: state.modalToShow,
                        toggleMobileLotListClick: state.toggleMobileLotListClick,
                        alternativeCurrency: action._0,
                        showLotCardList: state.showLotCardList,
                        showLotDetails: state.showLotDetails
                      };
            case /* SetShowLotCardList */3 :
                return {
                        modalToShow: state.modalToShow,
                        toggleMobileLotListClick: state.toggleMobileLotListClick,
                        alternativeCurrency: state.alternativeCurrency,
                        showLotCardList: action._0,
                        showLotDetails: state.showLotDetails
                      };
            case /* SetShowLotDetails */4 :
                return {
                        modalToShow: state.modalToShow,
                        toggleMobileLotListClick: state.toggleMobileLotListClick,
                        alternativeCurrency: state.alternativeCurrency,
                        showLotCardList: state.showLotCardList,
                        showLotDetails: action._0
                      };
            
          }
        }), {
        modalToShow: /* NoModal */0,
        toggleMobileLotListClick: false,
        alternativeCurrency: undefined,
        showLotCardList: true,
        showLotDetails: false
      });
  var dispatch = match$1[1];
  var state = match$1[0];
  var setAlternativeCurrency = React.useCallback(function (c) {
        Curry._1(dispatch, {
              TAG: /* SetAlternativeCurrency */2,
              _0: c
            });
      });
  var authToken = AuthTokenHook$LiveRoom.useToken("AuctionRoomPage-LiveRoom");
  var match$2 = Belt_Option.flatMap(auction.enrollment.result, (function (result) {
          return result.enrollmentResult;
        }));
  var paddleId = match$2 !== undefined && typeof match$2 === "object" && match$2.NAME === "EnrollmentAccepted" ? Caml_format.int_of_string(match$2.VAL.paddleId) : undefined;
  var me = React.useMemo((function () {
          return {
                  paddleId: paddleId,
                  authToken: authToken,
                  transactional: typeof authToken === "object" && authToken.NAME === "Authenticated" ? authToken.VAL.details.userType === "transactional" : false
                };
        }), [
        authToken,
        paddleId
      ]);
  var showSelectAccount = function (param) {
    Future.get(Utils_IdRestriction$LiveRoom.checkForId(undefined, me, undefined), (function (res) {
            var status = res.status;
            if (status !== 0) {
              if (status >= 5) {
                return ;
              } else {
                return Curry._1(dispatch, {
                            TAG: /* SetModalToShow */0,
                            _0: {
                              TAG: /* SubmitIdentificationModal */1,
                              _0: status
                            }
                          });
              }
            } else {
              return Curry._1(dispatch, {
                          TAG: /* SetModalToShow */0,
                          _0: /* SelectAccount */1
                        });
            }
          }));
  };
  var match$3 = React.useState(function () {
        
      });
  var setManualBidStateRefresh = match$3[1];
  var manualBidStateRefresh = match$3[0];
  var onSubscriptionError = function (id) {
    Curry._1(setManualBidStateRefresh, (function (param) {
            return id;
          }));
  };
  var shouldSkipSubscription = function (id) {
    return Belt_Option.mapWithDefault(manualBidStateRefresh, false, (function (sub) {
                  return sub === id;
                }));
  };
  withErrorRecovery(Curry._7(ClientapiQueries$LiveRoom.Subscriptions.BidStateByAuctionId.use, undefined, undefined, undefined, undefined, undefined, typeof authToken === "object" ? (
              authToken.NAME === "Authenticated" ? shouldSkipSubscription("BidStateByAuctionId") : true
            ) : (
              authToken === "Unauthenticated" ? shouldSkipSubscription("BidStateByAuctionId") : true
            ), Curry._2(ClientapiQueries$LiveRoom.Subscriptions.BidStateByAuctionId.makeVariables, auction.auctionId, undefined)), onSubscriptionError, "BidStateByAuctionId");
  React.useEffect((function () {
          if (Belt_Option.isSome(manualBidStateRefresh)) {
            Curry._1(setManualBidStateRefresh, (function (param) {
                    
                  }));
          }
          
        }), [manualBidStateRefresh]);
  withErrorRecovery(Curry._7(ClientapiQueries$LiveRoom.Subscriptions.LatestBidByAuctionId.use, undefined, undefined, undefined, undefined, undefined, typeof authToken === "object" && authToken.NAME === "Authenticated" ? shouldSkipSubscription("LatestBidByAuctionId") : true, Curry._2(ClientapiQueries$LiveRoom.Subscriptions.LatestBidByAuctionId.makeVariables, auction.auctionId, undefined)), onSubscriptionError, "LatestBidByAuctionId");
  withErrorRecovery(Curry._7(ClientapiQueries$LiveRoom.Subscriptions.SessionStateByAuction.use, undefined, undefined, undefined, undefined, undefined, shouldSkipSubscription("SessionStateByAuction"), Curry._2(ClientapiQueries$LiveRoom.Subscriptions.SessionStateByAuction.makeVariables, auction.auctionId, undefined)), onSubscriptionError, "SessionStateByAuction");
  withErrorRecovery(Curry._7(ClientapiQueries$LiveRoom.Subscriptions.BidCapByAuctionId.use, undefined, undefined, undefined, undefined, undefined, typeof authToken === "object" && authToken.NAME === "Authenticated" ? shouldSkipSubscription("BidCapByAuctionId") : true, Curry._2(ClientapiQueries$LiveRoom.Subscriptions.BidCapByAuctionId.makeVariables, auction.auctionId, undefined)), onSubscriptionError, "BidCapByAuctionId");
  withErrorRecovery(Curry._7(ClientapiQueries$LiveRoom.Subscriptions.CurrentLotForAuction.use, undefined, undefined, undefined, undefined, undefined, shouldSkipSubscription("CurrentLotForAuction"), Curry._2(ClientapiQueries$LiveRoom.Subscriptions.CurrentLotForAuction.makeVariables, auction.auctionId, undefined)), onSubscriptionError, "CurrentLotForAuction");
  withErrorRecovery(Curry._7(ClientapiQueries$LiveRoom.Subscriptions.AuctionBidPhaseByAuctionId.use, undefined, undefined, undefined, undefined, undefined, shouldSkipSubscription("AuctionBidPhaseByAuctionId"), Curry._2(ClientapiQueries$LiveRoom.Subscriptions.AuctionBidPhaseByAuctionId.makeVariables, auction.auctionId, undefined)), onSubscriptionError, "AuctionBidPhaseByAuctionId");
  withErrorRecovery(Curry._7(ClientapiQueries$LiveRoom.Subscriptions.EnrollmentResultByAuctionId.use, undefined, undefined, undefined, undefined, undefined, typeof authToken === "object" && authToken.NAME === "Authenticated" ? shouldSkipSubscription("EnrollmentResultByAuctionId") : true, Curry._2(ClientapiQueries$LiveRoom.Subscriptions.EnrollmentResultByAuctionId.makeVariables, auction.auctionId, undefined)), onSubscriptionError, "EnrollmentResultByAuctionId");
  withErrorRecovery(Curry._7(ClientapiQueries$LiveRoom.Subscriptions.PremiumLotStateForAuction.use, undefined, undefined, undefined, undefined, undefined, shouldSkipSubscription("PremiumLotStateByAuctionId"), Curry._2(ClientapiQueries$LiveRoom.Subscriptions.PremiumLotStateForAuction.makeVariables, auction.auctionId, undefined)), onSubscriptionError, "PremiumLotStateByAuctionId");
  React.useEffect((function () {
          ClockStore$LiveRoom.setServerTime(Date.now());
        }), []);
  var currentLot = auction.currentLot.lot;
  var match$4 = useLotOnDisplay(currentLot);
  var requestToViewLot = match$4[2];
  var lot = match$4[1];
  var selectedLotId = match$4[0];
  var match$5 = Curry._1(LiveStream$LiveRoom.Context.use, undefined);
  var breakpoint = Utils_Breakpoints$LiveRoom.useBreakpoint(undefined);
  React.useEffect((function () {
          Curry._1(dispatch, {
                TAG: /* SetShowLotCardList */3,
                _0: breakpoint !== /* DesktopAndTabletLandscape */4 && breakpoint !== /* TabletPortraitAndMobile */2 && breakpoint !== /* Mobile */1
              });
        }), [breakpoint]);
  var nextEnrollmentStep = function (enrollmentSuccessful, isAgentBidder) {
    if (typeof enrollmentSuccessful !== "object") {
      if (isAgentBidder) {
        return Curry._1(dispatch, {
                    TAG: /* SetModalToShow */0,
                    _0: /* PendingAgentModal */3
                  });
      } else {
        return Curry._1(dispatch, {
                    TAG: /* SetModalToShow */0,
                    _0: /* ActionNeededToBid */2
                  });
      }
    }
    var match = enrollmentSuccessful.VAL;
    Curry._1(dispatch, {
          TAG: /* SetModalToShow */0,
          _0: /* NoModal */0
        });
    var match$1 = me.authToken;
    var match$2 = auction.type;
    AnalyticsManager$LiveRoom.auctionRegistrationCompleted(auction.sapSaleNumber, "LiveRoom", undefined, undefined, Belt_Option.flatMap(auction.enrollment.restrictedDate, (function (prim) {
                return JSON.stringify(prim);
              })), "Approved", "LotPage", typeof match$1 === "object" && match$1.NAME === "Authenticated" ? match$1.VAL.details.userId : undefined, match[0], auction.auctionId, typeof match$2 === "object" || match$2 !== "Live" ? "Timed" : "Live", match[1]);
  };
  ShowSelectAccount$LiveRoom.use(auction.auctionId, Belt_Option.flatMap(auction.location, (function ($$location) {
              return AuctionRoomSharedContacts$LiveRoom.auctionLocationToSaleLocation(AuctionRoomSharedContacts$LiveRoom.getAuctionLocationType($$location.name));
            })), nextEnrollmentStep, showSelectAccount);
  var match$6 = Belt_Option.flatMap(currentLot, (function (lot) {
          return Belt_Option.map(lot.currentLotCardLotFragment.bidState, (function (bidState) {
                        return bidState.bidType;
                      }));
        }));
  var lotIsUpcomingOrLive;
  if (match$6 !== undefined && typeof match$6 === "object" && match$6.NAME === "LiveBidType") {
    var match$7 = match$6.VAL.liveBidPhase;
    lotIsUpcomingOrLive = match$7 === "Live" || match$7 === "Upcoming";
  } else {
    lotIsUpcomingOrLive = false;
  }
  if (lot !== undefined) {
    return React.createElement(AlternativeCurrency$LiveRoom.Context.Provider.make, {
                value: state.alternativeCurrency,
                children: React.createElement(LiveStream$LiveRoom.Provider.make, {
                      children: null
                    }, React.createElement(AuctionRoomPage$LayoutDesktopAndTabletLandscape, {
                          isTestAuction: auction.testRecord,
                          children: null
                        }, React.createElement("div", {
                              className: Curry._1(Css.style, {
                                    hd: Css.gridColumn(1, 4),
                                    tl: /* [] */0
                                  })
                            }, auction.testRecord ? React.createElement(TestAuctionBanner$LiveRoom.make, {}) : null), React.createElement("div", {
                              className: Curry._1(Css.style, {
                                    hd: Css.gridColumn(1, 4),
                                    tl: {
                                      hd: Css.background(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                                      tl: {
                                        hd: StyleConstants$LiveRoom.defaultBorder("bottom", undefined, undefined),
                                        tl: /* [] */0
                                      }
                                    }
                                  })
                            }, React.createElement(Header$LiveRoom.make, {
                                  fragment: auction.auctionHeaderAuctionFragment,
                                  me: me,
                                  sessionIdOnDisplay: Belt_Option.map(lot.lotDetailsLotFragment.session, (function (x) {
                                          return x.sessionId;
                                        })),
                                  toggleMobileLotListClick: (function (param) {
                                      Curry._1(dispatch, {
                                            TAG: /* SetToggleMobileLotListClick */1,
                                            _0: !state.toggleMobileLotListClick
                                          });
                                    }),
                                  setAlternativeCurrency: setAlternativeCurrency,
                                  showSelectAccount: showSelectAccount,
                                  lotIsUpcomingOrLive: lotIsUpcomingOrLive
                                })), React.createElement(PropSpread$LiveRoom.make, {
                              data: {
                                hd: {
                                  TAG: /* TestId */1,
                                  _0: "lotList"
                                },
                                tl: /* [] */0
                              },
                              children: React.createElement("div", {
                                    className: leftSideContainerStyle(state.showLotCardList)
                                  }, React.createElement(AuctionRoomPage$ToggleLotListButton, {
                                        showList: state.showLotCardList,
                                        onToggle: (function (toggle) {
                                            Curry._1(dispatch, {
                                                  TAG: /* SetShowLotCardList */3,
                                                  _0: toggle
                                                });
                                          })
                                      }), React.createElement("div", {
                                        "aria-hidden": !state.showLotCardList,
                                        className: Curry._1(Css.style, {
                                              hd: Css.display("flex"),
                                              tl: {
                                                hd: Css.flexDirection("column"),
                                                tl: {
                                                  hd: Css.height(Css.pct(100)),
                                                  tl: {
                                                    hd: Css.position("absolute"),
                                                    tl: {
                                                      hd: Css.width(Css.px(StyleConstants$LiveRoom.sidebarsWidth)),
                                                      tl: {
                                                        hd: Css.right(state.showLotCardList ? "zero" : Css.pct(100)),
                                                        tl: {
                                                          hd: Css.transition(StyleConstants$LiveRoom.animationFast, undefined, undefined, "all"),
                                                          tl: /* [] */0
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            })
                                      }, currentLot !== undefined ? React.createElement(CurrentLotCard$LiveRoom.make, {
                                              fragment: currentLot.currentLotCardLotFragment,
                                              isListHidden: !state.showLotCardList
                                            }) : null, React.createElement(LotCardList$LiveRoom.make, {
                                            fragment: auction.lotCardListAuctionFragment,
                                            selectedLotId: selectedLotId,
                                            selectLot: requestToViewLot,
                                            me: me,
                                            toggleMobileLotListClick: (function (param) {
                                                Curry._1(dispatch, {
                                                      TAG: /* SetToggleMobileLotListClick */1,
                                                      _0: !state.toggleMobileLotListClick
                                                    });
                                              })
                                          })))
                            }), React.createElement(MiddleSection$LiveRoom.make, {
                              me: me,
                              fragment: lot.lotDetailsLotFragment,
                              carousel: breakpoint === /* Desktop */0 || breakpoint === /* DesktopAndTabletLandscape */4 ? Caml_option.some(React.createElement(LotCarousel$LiveRoom.make, {
                                          me: me,
                                          lot: lot.lotDetailsLotFragment
                                        })) : undefined
                            }), React.createElement(FeedSection$LiveRoom.make, {
                              fragment: auction,
                              lot: lot,
                              authToken: authToken,
                              selectedLotId: selectedLotId,
                              eventFeedHeight: {
                                NAME: "subtract",
                                VAL: [
                                  Css.pct(100),
                                  {
                                    NAME: "pxFloat",
                                    VAL: match$5[0].floatingStreamContainerHeight
                                  }
                                ]
                              },
                              showSelectAccount: showSelectAccount,
                              showIncompleteRegistrationModal: (function (param) {
                                  Curry._1(dispatch, {
                                        TAG: /* SetModalToShow */0,
                                        _0: /* ActionNeededPendingEnrollment */6
                                      });
                                })
                            })), React.createElement(AuctionRoomPage$LayoutTabletPortraitAndMobile, {
                          isTestAuction: auction.testRecord,
                          children: null
                        }, React.createElement("div", {
                              className: Curry._1(Css.style, {
                                    hd: Css.gridColumn(1, 4),
                                    tl: /* [] */0
                                  })
                            }, auction.testRecord ? React.createElement(TestAuctionBanner$LiveRoom.make, {}) : null), React.createElement("div", {
                              className: Curry._1(Css.style, {
                                    hd: Css.background(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                                    tl: {
                                      hd: Css.gridColumn(1, 4),
                                      tl: {
                                        hd: StyleConstants$LiveRoom.defaultBorder("bottom", undefined, undefined),
                                        tl: /* [] */0
                                      }
                                    }
                                  })
                            }, React.createElement(Header$LiveRoom.make, {
                                  fragment: auction.auctionHeaderAuctionFragment,
                                  me: me,
                                  sessionIdOnDisplay: Belt_Option.map(lot.lotDetailsLotFragment.session, (function (x) {
                                          return x.sessionId;
                                        })),
                                  toggleMobileLotListClick: (function (param) {
                                      Curry._1(dispatch, {
                                            TAG: /* SetToggleMobileLotListClick */1,
                                            _0: !state.toggleMobileLotListClick
                                          });
                                    }),
                                  showMobileLotList: state.toggleMobileLotListClick,
                                  setAlternativeCurrency: setAlternativeCurrency,
                                  showSelectAccount: showSelectAccount,
                                  lotIsUpcomingOrLive: lotIsUpcomingOrLive
                                })), React.createElement("div", {
                              className: Curry._1(Css.style, {
                                    hd: Css.display(state.toggleMobileLotListClick ? "flex" : "none"),
                                    tl: /* [] */0
                                  })
                            }, React.createElement(LotCardList$LiveRoom.make, {
                                  fragment: auction.lotCardListAuctionFragment,
                                  selectedLotId: selectedLotId,
                                  selectLot: requestToViewLot,
                                  me: me,
                                  toggleMobileLotListClick: (function (param) {
                                      Curry._1(dispatch, {
                                            TAG: /* SetToggleMobileLotListClick */1,
                                            _0: !state.toggleMobileLotListClick
                                          });
                                    })
                                })), React.createElement("div", {
                              className: Curry._1(Css.style, {
                                    hd: Css.overflow("hidden"),
                                    tl: {
                                      hd: Css.display(state.toggleMobileLotListClick ? "none" : "grid"),
                                      tl: {
                                        hd: Css.gridTemplateRows({
                                              hd: {
                                                NAME: "minmax",
                                                VAL: [
                                                  "zero",
                                                  Css.pct(100)
                                                ]
                                              },
                                              tl: {
                                                hd: {
                                                  NAME: "minmax",
                                                  VAL: [
                                                    "zero",
                                                    Css.auto
                                                  ]
                                                },
                                                tl: /* [] */0
                                              }
                                            }),
                                        tl: /* [] */0
                                      }
                                    }
                                  })
                            }, React.createElement("div", {
                                  className: Curry._1(Css.style, {
                                        hd: Css.overflowY("auto"),
                                        tl: {
                                          hd: Css.overflowX("hidden"),
                                          tl: /* [] */0
                                        }
                                      })
                                }, React.createElement(CurrentLotCard$LiveRoom.make, {
                                      fragment: lot.currentLotCardLotFragment,
                                      isListHidden: false,
                                      isMobile: true,
                                      carousel: breakpoint !== /* Desktop */0 && breakpoint !== /* DesktopAndTabletLandscape */4 ? Caml_option.some(React.createElement(LotCarousel$LiveRoom.make, {
                                                  me: me,
                                                  lot: lot.lotDetailsLotFragment,
                                                  isMobile: true
                                                })) : undefined
                                    }), React.createElement(SterlingTypography$LiveRoom.ButtonLink12Regular.make, {
                                      className: Curry._1(Css.style, {
                                            hd: Css.display("block"),
                                            tl: {
                                              hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlue60_nohashtag)),
                                              tl: {
                                                hd: Css.margin4(Css.px(8), "zero", "zero", Css.px(16)),
                                                tl: {
                                                  hd: Css.width("fitContent"),
                                                  tl: /* [] */0
                                                }
                                              }
                                            }
                                          }),
                                      onClick: (function (param) {
                                          Curry._1(dispatch, {
                                                TAG: /* SetShowLotDetails */4,
                                                _0: true
                                              });
                                        }),
                                      children: Curry._1(match.t, "Common_LotDetails")
                                    }), state.showLotDetails ? React.createElement(LotContent$LiveRoom.TabletAndMobileContent.make, {
                                        lot: lot.lotDetailsLotFragment,
                                        me: me,
                                        closeLotDetails: (function (param) {
                                            Curry._1(dispatch, {
                                                  TAG: /* SetShowLotDetails */4,
                                                  _0: false
                                                });
                                          })
                                      }) : null, React.createElement(FeedSection$LiveRoom.Feed.make, {
                                      currency: auction.currency,
                                      lot: lot,
                                      eventFeedHeight: Css.pct(100),
                                      direction: "TopDown",
                                      className: Curry._1(Css.style, {
                                            hd: Css.padding(Css.px(8)),
                                            tl: {
                                              hd: Css.height(Css.auto),
                                              tl: /* [] */0
                                            }
                                          })
                                    })), React.createElement(FeedSection$LiveRoom.CTASection.make, {
                                  fragment: auction,
                                  lot: lot,
                                  showSelectAccount: showSelectAccount,
                                  showIncompleteRegistrationModal: (function (param) {
                                      Curry._1(dispatch, {
                                            TAG: /* SetModalToShow */0,
                                            _0: /* ActionNeededPendingEnrollment */6
                                          });
                                    }),
                                  authToken: authToken,
                                  selectedLotId: selectedLotId,
                                  className: Curry._1(Css.style, {
                                        hd: Css.padding(Css.px(8)),
                                        tl: /* [] */0
                                      })
                                }))), React.createElement(AuctionRoomPage$ModalHandler, {
                          fragment: auction,
                          enrollmentModalFragment: auction.auctionEnrollmentModalFragment,
                          welcomeAuctionRoomModalFragment: auction.welcomeAuctionRoomModalFragment,
                          modalToShow: state.modalToShow,
                          setModalToShow: (function (modal) {
                              Curry._1(dispatch, {
                                    TAG: /* SetModalToShow */0,
                                    _0: modal
                                  });
                            }),
                          me: me,
                          authToken: authToken,
                          selectAccountInQuery: props.selectAccountInQuery,
                          auctionUrl: Utils_Auction$LiveRoom.getAuctionUrl(auction.slug.name, auction.slug.year, undefined, undefined),
                          nextEnrollmentStep: nextEnrollmentStep
                        }))
              });
  } else {
    return null;
  }
}

var AuctionBySlug;

var BidStateByAuctionId;

var LatestBidByAuctionId;

var SessionStateByAuction;

var LotOnDisplayQuery;

var LotOnDisplayLotFragment;

var BidCapByAuctionId;

var CurrentLotForAuction;

var AuctionBidPhaseByAuctionId;

var EnrollmentResultByAuctionId;

var PremiumLotStateByAuctionId;

var make = AuctionRoomPage;

export {
  leftSideContainerStyle ,
  LayoutDesktopAndTabletLandscape ,
  LayoutTabletPortraitAndMobile ,
  ToggleLotListButton ,
  ModalHandler ,
  withErrorRecovery ,
  AuctionBySlug ,
  BidStateByAuctionId ,
  LatestBidByAuctionId ,
  SessionStateByAuction ,
  LotOnDisplayQuery ,
  LotOnDisplayLotFragment ,
  BidCapByAuctionId ,
  CurrentLotForAuction ,
  AuctionBidPhaseByAuctionId ,
  EnrollmentResultByAuctionId ,
  PremiumLotStateByAuctionId ,
  useLotOnDisplay ,
  make ,
}
/* Css Not a pure module */
